/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiProjectCategoriesCreateProjectCategoryPost } from '../fn/project-categories/api-project-categories-create-project-category-post';
import { ApiProjectCategoriesCreateProjectCategoryPost$Params } from '../fn/project-categories/api-project-categories-create-project-category-post';
import { apiProjectCategoriesCreateProjectCategoryPost$Plain } from '../fn/project-categories/api-project-categories-create-project-category-post-plain';
import { ApiProjectCategoriesCreateProjectCategoryPost$Plain$Params } from '../fn/project-categories/api-project-categories-create-project-category-post-plain';
import { apiProjectCategoriesDeleteProjectCategoryDelete } from '../fn/project-categories/api-project-categories-delete-project-category-delete';
import { ApiProjectCategoriesDeleteProjectCategoryDelete$Params } from '../fn/project-categories/api-project-categories-delete-project-category-delete';
import { apiProjectCategoriesDeleteProjectCategoryDelete$Plain } from '../fn/project-categories/api-project-categories-delete-project-category-delete-plain';
import { ApiProjectCategoriesDeleteProjectCategoryDelete$Plain$Params } from '../fn/project-categories/api-project-categories-delete-project-category-delete-plain';
import { apiProjectCategoriesGetProjectCategoriesPost } from '../fn/project-categories/api-project-categories-get-project-categories-post';
import { ApiProjectCategoriesGetProjectCategoriesPost$Params } from '../fn/project-categories/api-project-categories-get-project-categories-post';
import { apiProjectCategoriesGetProjectCategoriesPost$Plain } from '../fn/project-categories/api-project-categories-get-project-categories-post-plain';
import { ApiProjectCategoriesGetProjectCategoriesPost$Plain$Params } from '../fn/project-categories/api-project-categories-get-project-categories-post-plain';
import { apiProjectCategoriesGetProjectsWithCategoriesGet } from '../fn/project-categories/api-project-categories-get-projects-with-categories-get';
import { ApiProjectCategoriesGetProjectsWithCategoriesGet$Params } from '../fn/project-categories/api-project-categories-get-projects-with-categories-get';
import { apiProjectCategoriesGetProjectsWithCategoriesGet$Plain } from '../fn/project-categories/api-project-categories-get-projects-with-categories-get-plain';
import { ApiProjectCategoriesGetProjectsWithCategoriesGet$Plain$Params } from '../fn/project-categories/api-project-categories-get-projects-with-categories-get-plain';
import { apiProjectCategoriesUpdateProjectCategoryPatch } from '../fn/project-categories/api-project-categories-update-project-category-patch';
import { ApiProjectCategoriesUpdateProjectCategoryPatch$Params } from '../fn/project-categories/api-project-categories-update-project-category-patch';
import { apiProjectCategoriesUpdateProjectCategoryPatch$Plain } from '../fn/project-categories/api-project-categories-update-project-category-patch-plain';
import { ApiProjectCategoriesUpdateProjectCategoryPatch$Plain$Params } from '../fn/project-categories/api-project-categories-update-project-category-patch-plain';
import { CreateProjectCategoryCommandResult } from '../models/create-project-category-command-result';
import { DeleteProjectCategoryCommandResult } from '../models/delete-project-category-command-result';
import { GetProjectCategoriesQueryResult } from '../models/get-project-categories-query-result';
import { GetProjectsWithCategoriesQueryResult } from '../models/get-projects-with-categories-query-result';
import { UpdateProjectCategoryCommandResult } from '../models/update-project-category-command-result';

@Injectable({ providedIn: 'root' })
export class ProjectCategoriesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiProjectCategoriesCreateProjectCategoryPost()` */
  static readonly ApiProjectCategoriesCreateProjectCategoryPostPath = '/api/ProjectCategories/CreateProjectCategory';

  /**
   * Creates a new Project Category.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectCategoriesCreateProjectCategoryPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectCategoriesCreateProjectCategoryPost$Plain$Response(params?: ApiProjectCategoriesCreateProjectCategoryPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectCategoryCommandResult>> {
    return apiProjectCategoriesCreateProjectCategoryPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new Project Category.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectCategoriesCreateProjectCategoryPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectCategoriesCreateProjectCategoryPost$Plain(params?: ApiProjectCategoriesCreateProjectCategoryPost$Plain$Params, context?: HttpContext): Observable<CreateProjectCategoryCommandResult> {
    return this.apiProjectCategoriesCreateProjectCategoryPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectCategoryCommandResult>): CreateProjectCategoryCommandResult => r.body)
    );
  }

  /**
   * Creates a new Project Category.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectCategoriesCreateProjectCategoryPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectCategoriesCreateProjectCategoryPost$Response(params?: ApiProjectCategoriesCreateProjectCategoryPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectCategoryCommandResult>> {
    return apiProjectCategoriesCreateProjectCategoryPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new Project Category.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectCategoriesCreateProjectCategoryPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectCategoriesCreateProjectCategoryPost(params?: ApiProjectCategoriesCreateProjectCategoryPost$Params, context?: HttpContext): Observable<CreateProjectCategoryCommandResult> {
    return this.apiProjectCategoriesCreateProjectCategoryPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectCategoryCommandResult>): CreateProjectCategoryCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectCategoriesDeleteProjectCategoryDelete()` */
  static readonly ApiProjectCategoriesDeleteProjectCategoryDeletePath = '/api/ProjectCategories/DeleteProjectCategory';

  /**
   * Deletes an existing Project Category.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectCategoriesDeleteProjectCategoryDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectCategoriesDeleteProjectCategoryDelete$Plain$Response(params?: ApiProjectCategoriesDeleteProjectCategoryDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectCategoryCommandResult>> {
    return apiProjectCategoriesDeleteProjectCategoryDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes an existing Project Category.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectCategoriesDeleteProjectCategoryDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectCategoriesDeleteProjectCategoryDelete$Plain(params?: ApiProjectCategoriesDeleteProjectCategoryDelete$Plain$Params, context?: HttpContext): Observable<DeleteProjectCategoryCommandResult> {
    return this.apiProjectCategoriesDeleteProjectCategoryDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectCategoryCommandResult>): DeleteProjectCategoryCommandResult => r.body)
    );
  }

  /**
   * Deletes an existing Project Category.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectCategoriesDeleteProjectCategoryDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectCategoriesDeleteProjectCategoryDelete$Response(params?: ApiProjectCategoriesDeleteProjectCategoryDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectCategoryCommandResult>> {
    return apiProjectCategoriesDeleteProjectCategoryDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes an existing Project Category.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectCategoriesDeleteProjectCategoryDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectCategoriesDeleteProjectCategoryDelete(params?: ApiProjectCategoriesDeleteProjectCategoryDelete$Params, context?: HttpContext): Observable<DeleteProjectCategoryCommandResult> {
    return this.apiProjectCategoriesDeleteProjectCategoryDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectCategoryCommandResult>): DeleteProjectCategoryCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectCategoriesUpdateProjectCategoryPatch()` */
  static readonly ApiProjectCategoriesUpdateProjectCategoryPatchPath = '/api/ProjectCategories/UpdateProjectCategory';

  /**
   * Updates an existing Project Category.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectCategoriesUpdateProjectCategoryPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectCategoriesUpdateProjectCategoryPatch$Plain$Response(params?: ApiProjectCategoriesUpdateProjectCategoryPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectCategoryCommandResult>> {
    return apiProjectCategoriesUpdateProjectCategoryPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing Project Category.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectCategoriesUpdateProjectCategoryPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectCategoriesUpdateProjectCategoryPatch$Plain(params?: ApiProjectCategoriesUpdateProjectCategoryPatch$Plain$Params, context?: HttpContext): Observable<UpdateProjectCategoryCommandResult> {
    return this.apiProjectCategoriesUpdateProjectCategoryPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectCategoryCommandResult>): UpdateProjectCategoryCommandResult => r.body)
    );
  }

  /**
   * Updates an existing Project Category.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectCategoriesUpdateProjectCategoryPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectCategoriesUpdateProjectCategoryPatch$Response(params?: ApiProjectCategoriesUpdateProjectCategoryPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectCategoryCommandResult>> {
    return apiProjectCategoriesUpdateProjectCategoryPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing Project Category.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectCategoriesUpdateProjectCategoryPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectCategoriesUpdateProjectCategoryPatch(params?: ApiProjectCategoriesUpdateProjectCategoryPatch$Params, context?: HttpContext): Observable<UpdateProjectCategoryCommandResult> {
    return this.apiProjectCategoriesUpdateProjectCategoryPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectCategoryCommandResult>): UpdateProjectCategoryCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectCategoriesGetProjectCategoriesPost()` */
  static readonly ApiProjectCategoriesGetProjectCategoriesPostPath = '/api/ProjectCategories/GetProjectCategories';

  /**
   * Gets the list of all Project Categories.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectCategoriesGetProjectCategoriesPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectCategoriesGetProjectCategoriesPost$Plain$Response(params?: ApiProjectCategoriesGetProjectCategoriesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectCategoriesQueryResult>> {
    return apiProjectCategoriesGetProjectCategoriesPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the list of all Project Categories.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectCategoriesGetProjectCategoriesPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectCategoriesGetProjectCategoriesPost$Plain(params?: ApiProjectCategoriesGetProjectCategoriesPost$Plain$Params, context?: HttpContext): Observable<GetProjectCategoriesQueryResult> {
    return this.apiProjectCategoriesGetProjectCategoriesPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectCategoriesQueryResult>): GetProjectCategoriesQueryResult => r.body)
    );
  }

  /**
   * Gets the list of all Project Categories.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectCategoriesGetProjectCategoriesPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectCategoriesGetProjectCategoriesPost$Response(params?: ApiProjectCategoriesGetProjectCategoriesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectCategoriesQueryResult>> {
    return apiProjectCategoriesGetProjectCategoriesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the list of all Project Categories.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectCategoriesGetProjectCategoriesPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectCategoriesGetProjectCategoriesPost(params?: ApiProjectCategoriesGetProjectCategoriesPost$Params, context?: HttpContext): Observable<GetProjectCategoriesQueryResult> {
    return this.apiProjectCategoriesGetProjectCategoriesPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectCategoriesQueryResult>): GetProjectCategoriesQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectCategoriesGetProjectsWithCategoriesGet()` */
  static readonly ApiProjectCategoriesGetProjectsWithCategoriesGetPath = '/api/ProjectCategories/GetProjectsWithCategories';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectCategoriesGetProjectsWithCategoriesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectCategoriesGetProjectsWithCategoriesGet$Plain$Response(params?: ApiProjectCategoriesGetProjectsWithCategoriesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectsWithCategoriesQueryResult>> {
    return apiProjectCategoriesGetProjectsWithCategoriesGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectCategoriesGetProjectsWithCategoriesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectCategoriesGetProjectsWithCategoriesGet$Plain(params?: ApiProjectCategoriesGetProjectsWithCategoriesGet$Plain$Params, context?: HttpContext): Observable<GetProjectsWithCategoriesQueryResult> {
    return this.apiProjectCategoriesGetProjectsWithCategoriesGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectsWithCategoriesQueryResult>): GetProjectsWithCategoriesQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectCategoriesGetProjectsWithCategoriesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectCategoriesGetProjectsWithCategoriesGet$Response(params?: ApiProjectCategoriesGetProjectsWithCategoriesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectsWithCategoriesQueryResult>> {
    return apiProjectCategoriesGetProjectsWithCategoriesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectCategoriesGetProjectsWithCategoriesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectCategoriesGetProjectsWithCategoriesGet(params?: ApiProjectCategoriesGetProjectsWithCategoriesGet$Params, context?: HttpContext): Observable<GetProjectsWithCategoriesQueryResult> {
    return this.apiProjectCategoriesGetProjectsWithCategoriesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectsWithCategoriesQueryResult>): GetProjectsWithCategoriesQueryResult => r.body)
    );
  }

}
